import { useEffect } from "react";
import API from "../../api";
import ActionTypes from "../../store/actionTypes";
import { useCentralStore } from "../../store/appContext";
import resources from '../../components/common/resources.json'
import SGPReportsFilter from "../operationalReport/SGPReportsFilter";
import { displayPgmName, exportChartGraph, isEmpty } from "../../utils/functionUtils";
import SHDashboardMenu from "./SHDashboardMenu";
import SHDashboardData from "./SHDashboardData";
import Download from '../../assets/icons/downloadNew'
import exportToCSVInventory from "../../components/common/hepler/export-to-csv-submatricsData";
import ProgramSummary from "./ProgramSummary";
import AsurionLogo from '../../assets/icons/asurionLogo'
// import { setCursorPositioning } from "../../utils/functionUtils";
import FinanceReconReport from "./FinanceReconReport";
import SlaReport from "./SlaReport";
import SLAReportContainer from "./SLAReport/SLAReportContainer";
import GlossaryReport from "./GlossaryReport"
import TrendCompoent from "./StarHubReports/TrendCompoent";
import DownloadReportsNew from "./DownloadReportNew";
import CustomerValueManagement from "./CustomerValueManagement";
import SalesReportContainer from "./SalesReport/SalesReportContainer";
import ProgramSummaryGlossary from "./ProgramSummaryGlossary";
import * as XLSX from 'xlsx';

const MainContainer = () => {

    const [ { carrierThemeData, reportFilterDuration, userData, userDetails, selectedTab, projectName, selectedReportFilter, reportCountSuccess, chartReportCountSuccess, programName }, dispatch] = useCentralStore()
    const { theme } = carrierThemeData;

    const setLoading = (action) => {
        dispatch({ type: ActionTypes.SET_LOADING, payload: action });
      };

    useEffect(() => {
        if(!isEmpty(reportFilterDuration?.duration) && (!isEmpty(reportFilterDuration?.endDate) || !isEmpty(reportFilterDuration?.startDate) || !isEmpty(reportFilterDuration?.type)) && projectName === 'Real Time Service Request Report') {
        let payload = {
          StartDate: reportFilterDuration?.startDate,
          EndDate: reportFilterDuration?.endDate,
          // StartDate: '2023-05-01 00:00:00',
          // EndDate: '2023-05-31 23:59:59',
          ReportType: 'All'
      };
      setLoading(true)
      dispatch({
        type: ActionTypes.SET_DASHBOARD_LOADING,
        payload: true,
      });
      API[ActionTypes.GET_STARHUB_REPORT_COUNT](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
      .then(({ data }) => {
          setLoading(false);
          if (data) {
            dispatch({
              type: ActionTypes.SET_DASHBOARD_LOADING,
              payload: false,
            });
            dispatch({
              type: ActionTypes.GET_STARHUB_REPORT_COUNT_SUCCESS,
              payload: data,
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: ActionTypes.GET_STARHUB_REPORT_COUNT_FAILURE,
            payload: err,
          });
          dispatch({
            type: ActionTypes.SET_DASHBOARD_LOADING,
            payload: false,
          });
          dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
          let _payload = {
            level: resources.POST_LOGGER_ERROR,
            category: resources.POST_LOGGER_API,
            ApiName: resources.POST_LOGGER_APINAME,
            message: {
              error: err,
              info: {
                idToken: "",
              },
            },
          };
          API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
        });
        }
      }, [reportFilterDuration])

      const downloadTrendSRData = () => {
        const resDataKeys = ['NPSCount', 'EnrollmentReportCount', 'ServiceRequestReportCount']
        // 'ServiceRequestRevenueCount', 

        const workbook = XLSX.utils.book_new();

    resDataKeys.forEach((key) => {
        const totalKeys = {};
        const colLabels = [];
        const data = chartReportCountSuccess?.[key] || [];

        // Collect all unique keys for column labels
        data.forEach((current) => {
            Object.keys(current).forEach((k) => {
                totalKeys[k] = 1;
            });
        });

        // Generate column labels
        Object.keys(totalKeys).forEach((k) => {
            if (k !== "SrStatus" && k !== "Count" && k !== "Total Service Requests") {
                colLabels.push(k);
            }
        });

        // Prepare data for the sheet
        const sheetData = [colLabels.map((k) => k?.replace(/([a-z0-9])([A-Z])/g, "$1 $2")?.toUpperCase())];
        data.forEach((row) => {
            const rowData = colLabels.map((col) => row[col] || "");
            sheetData.push(rowData);
        });

        // Add sheet to workbook
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, key);
    });

    // Export the workbook
    XLSX.writeFile(workbook, 'RealTimeServiceRequest_Report.xlsx');

        // for(let r = 0; r<resDataKeys?.length; r++){
        //   const colLables = []
        //   const totalKeys = {};
        //   chartReportCountSuccess?.[resDataKeys[r]]?.reduce((acc, current) => {
        //     const keys = Object.keys(current);
        //     for (var i in keys) {
        //       totalKeys[keys[i]] = 1;
        //     }
        //   }, totalKeys);
  
        //   var keys = Object.keys(totalKeys);
        //   for (let i in keys) {
        //     if (keys[i] !== "SrStatus" && keys[i] !== "Count" && keys[i] !== "Total Service Requests") {
        //       colLables.push({
        //         title: keys[i]?.replace(/([a-z0-9])([A-Z])/g, "$1 $2")?.toUpperCase(),
        //         dataIndex: keys[i],
        //         key: keys[i],
        //         width: 280
        //       });
        //     }
        //   }
  
        //   exportToCSVInventory(
        //     colLables,
        //     chartReportCountSuccess?.[resDataKeys[r]],
        //     "",
        //     "",
        //     `${resDataKeys[r]?.replace('EnrollmentReportCount', 'Subscription')?.replace('Report', '')?.replace('Count', '')} Report`,
        //     dispatch,
        //     ActionTypes
        // )
        // }
      }

      useEffect(() => {
          if(reportFilterDuration && (projectName === "Customer Service SLA Report" || projectName === 'Technical Service SLA Report' || selectedTab ==="SLA Report")){
            let payload = {
              idToken: userData?.access_token,
              month: reportFilterDuration?.duration
            };
      
            setLoading(true);  
            API[ActionTypes.GET_SLA_REPORTS_DETAILS](payload, userDetails && userDetails?.email?.split("@")?.[0])
              .then(({ data }) => {
                setLoading(false);  
                if (data) {
                  dispatch({
                    type: ActionTypes.GET_SLA_REPORTS_DETAILS_SUCCESS,
                    payload: data,
                  });
                }
              })
              .catch((err) => {
                dispatch({
                  type: ActionTypes.GET_SLA_REPORTS_DETAILS_FAILURE,
                  payload: err,
                });
                dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
                let _payload = {
                  level: resources.POST_LOGGER_ERROR,
                  category: resources.POST_LOGGER_API,
                  ApiName: resources.POST_LOGGER_APINAME,
                  message: {
                    error: err,
                    info: {
                      idToken: "",
                    },
                  },
                };
                API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
              }
            )
          }
      }, [reportFilterDuration, projectName])
     
      // const [animate, setAnimate] = useState(null);
      // const [isOpen, openPopup] = useState(false);
      // const handleOpen = (e) => {
      //   setCursorPositioning(e);
      //   setAnimate("modal-space-in");
      //   openPopup(true);
      // };
      // const handleClose = () => {
      //   setAnimate("modal-space-out");
      //   setTimeout(() => openPopup(false), 1000);
      // };   

      const dynamicStyle = {
        '--border-b-color': theme?.colors?.primary,
        '--background-color': theme?.colors?.primary,
    };

    const handleHomeClick = () => {
      dispatch({
        type: ActionTypes.SET_PROJECT_NAME,
        payload: null,
      });
      dispatch({ type: ActionTypes.SET_SELECTED_TAB, payload: null });
      dispatch({ type: ActionTypes.SET_PROGRAM_NAME, data: "" });
      dispatch({ type: ActionTypes.SGP_SET_REPORT_FILTER_DURATION, payload: {
        type: null,
        startDate: null,
        endDate: null,
        duration: null
      }})
      
      dispatch({ type: ActionTypes.GET_STARHUB_REPORT_COUNT_SUCCESS, payload: null})
      dispatch({ type: ActionTypes.GET_STARHUB_REPORT_COUNT_DETAILS_SUCCESS, payload: null})
      dispatch({ type: ActionTypes.GET_STARHUB_REPORT_DETAILS_SUCCESS, payload: null})
  
      dispatch({ type: ActionTypes.SGP_SET_REPORT_FILTER, payload: 'real time'})
    };

    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    const currentDate = new Date(new Date());
    
    const currentMonth = currentDate.getMonth(); // Month (0-11)
    const currentYear = currentDate.getFullYear(); // Year

    let prevMonthIndex = currentMonth - 1;
    let prevYear = currentYear;

    if (prevMonthIndex < 0) {
        prevMonthIndex = 11; // December
        prevYear--; // Decrement year
    }

    const prevMonthName = months[prevMonthIndex];
    const prevMonth = `${prevMonthName} ${prevYear}`

    return(
        <>
        <div className="bg-[#F5F5F5] w-full mb-6">
            <ol class="py-2 rounded text-[#363636] flex w-[85%] mx-auto">
              <li class="px-2 cursor-pointer"><a onClick={() => handleHomeClick()} class="no-underline text-black">Home</a></li>
              <li>/</li>
              <li class="px-2">
                <a class="no-underline text-[#363636] font-bold">
                  {displayPgmName(programName) || programName}
                </a>
              </li>
            </ol>
          </div>
        <div className="w-[85%] mx-auto">
          {programName?.toLowerCase() === 'program summary' ?
            <div className="flex justify-between borderBottomStyle" style={dynamicStyle}>
              <SHDashboardMenu prevMonth={prevMonth} />
              {/* <p className="text-[#363636] font-semibold text-2xl mb-4 pl-2">
                  {prevMonth}
              </p> */}
              {selectedTab !=="Glossary" &&
                <>
                  <div className={`cursor-pointer pl-1 flex justify-center items-center`} onClick={(e) => exportChartGraph(e, 'pgmSummary', 'ProgramSummary')}>
                    <Download className="" fill={'black'} />
                    {/* <DownloadIcon className="" fill={theme?.colors?.primary} />*/}
                    <div className={`text-black text=[14px] font-bold ml-2`}>
                      Export Chart
                    </div>
                  </div>
                </>
              }
            </div>
            :
          <div className={`flex justify-between mb-4 ${programName !== 'Customer Value Management' ? 'borderBottomStyle' : ''} `} style={dynamicStyle}>
            <SHDashboardMenu />
            {(selectedTab !== 'Monthly Trends' && 
              selectedTab !== 'SLA calculation methodology' && 
              selectedTab !== "Glossary" && 
              projectName !== 'Program Summary' && 
              (projectName !== "Finance Reconciliation & Invoice" || selectedTab ==="SLA Report") && 
              // projectName !== "Finance Reconciliation" &&
              projectName !== 'Download Reports' &&
              projectName !== 'Customer Value Management'
              // projectName !== 'Sales Report'
            ) &&
                <SGPReportsFilter 
                    selectedReportFilter={selectedReportFilter} 
                    dispatch={dispatch}
                    ActionTypes={ActionTypes}
                />
            }
            {(((projectName === "Customer Service SLA Report" ||  projectName === "Technical Service SLA Report" || projectName === "Sales Report") && selectedTab === 'Monthly Trends') || 
              projectName === "Customer Value Management") &&
                <>
                  <div className={`cursor-pointer pl-1 flex justify-end items-center mb-3`} onClick={(e) => exportChartGraph(e, projectName.replace(/\s+/g, ''), projectName.replace(/\s+/g, ''))}>
                      <Download className="" fill={'black'} />
                      <div className={`text-black text=[14px] font-bold ml-2`}>
                          Export Chart
                      </div>
                  </div>
                </>
            }
            {(projectName === 'Real Time Service Request Report' && selectedTab === 'Monthly Trends' && chartReportCountSuccess) &&
              <div className="flex">
                  <div className={`cursor-pointer pl-1 flex justify-center items-center ${
                      selectedTab === 'HomePage' ? "backgroundStyle font-bold rounded-lg" : "" }`}
                      style={dynamicStyle}>
                    <div className="flex items-center" 
                      onClick={(e) => exportChartGraph(e, (programName + selectedTab).replace(/\s+/g, ''), programName.replace(/\s+/g, ''))}
                      >
                        <Download className="" fill={'black'} />
                      {/* <DownloadIcon className="" fill={theme?.colors?.primary} />*/}
                          <div className={`text-black text=[14px] font-bold ml-2`}>
                              Export Chart
                          </div>
                      </div>
                  </div>
                  <div className={`cursor-pointer pl-1 flex justify-center items-center ${
                      selectedTab === 'HomePage' ? "backgroundStyle font-bold rounded-lg" : "" }`}
                      style={dynamicStyle}>
                    <div className="flex items-center" 
                      onClick={() => downloadTrendSRData()}
                      >
                        <Download className="" fill={'black'} />
                      {/* <DownloadIcon className="" fill={theme?.colors?.primary} />*/}
                          <div className={`text-black text=[14px] font-bold ml-2`}>
                              Download report here
                          </div>
                      </div>
                  </div>
            </div>
            }
          </div>}
        {((selectedTab === 'Real Time' || selectedTab === 'DownloadReport') && reportCountSuccess) &&
          <SHDashboardData />
        }
        {(programName === 'Real Time Service Request Report' && selectedTab === 'Monthly Trends' && chartReportCountSuccess) &&
          <TrendCompoent />
        }
        {(projectName === "Customer Service SLA Report" ||  projectName === "Technical Service SLA Report") &&
          <SLAReportContainer />
        }
        {projectName === "Program Summary" && selectedTab ==="Program Summary" &&
          <ProgramSummary />
        }
        {projectName === "Program Summary" && selectedTab ==="Glossary" &&
          <ProgramSummaryGlossary selectedTab={selectedTab} projectName={projectName} theme={theme} />
        }
        {(projectName === "Finance Reconciliation & Invoice" || programName === 'Finance Reconciliation') && selectedTab !=="SLA Report" && selectedTab !== "Glossary" &&
          <FinanceReconReport/>
        }
        {projectName === "Finance Reconciliation & Invoice" && selectedTab ==="SLA Report" &&
          <SlaReport/>
        }
        {projectName === "Real Time Service Request Report" && selectedTab ==="Glossary" &&
          <GlossaryReport selectedTab={selectedTab} projectName={projectName} theme={theme} />
        }
        {projectName === "Finance Reconciliation & Invoice" && selectedTab ==="Glossary" &&
          <GlossaryReport selectedTab={selectedTab} projectName={projectName} theme={theme} />
        }
        {projectName === "Download Reports" &&
          <DownloadReportsNew selectedTab={selectedTab} projectName={projectName}/>
        }
        {projectName === "Customer Value Management" &&
          <CustomerValueManagement />
        }
        {projectName === "Sales Report" &&
          <SalesReportContainer />
        }
      </div>
      {/* <div className="fixed bottom-0 right-[2%]">
          <AsurionLogo className="" />
      </div> */}
    </>
    )
}

export default MainContainer